/** @jsx jsx */
import { jsx, Text } from "theme-ui";

function SiteName({ className, name, variant, hide }) {
  const hideOffscreen = {
    position: "absolute",
    left: "-10000px",
    top: "auto",
    width: "1px",
    height: "1px",
    overflow: "hidden",
  };

  return (
    <Text
      as="h1"
      variant={variant}
      className={className}
      sx={hide ? { ...hideOffscreen } : ""}
    >
      {name}
    </Text>
  );
}

export default SiteName;
